export default __webpack_public_path__ + "a1bbaca78b4ec6b2043cb39bc32bf9f9.svg";